'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DateManager = undefined;

var _isString = require('d2-utilizr/lib/isString');

var _isString2 = _interopRequireDefault(_isString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _DateManager;

exports.DateManager = _DateManager;
exports.DateManager = _DateManager = function DateManager() {
    this.klass = _DateManager;
};

_DateManager.toDate = function (dateString) {
    return (0, _isString2.default)(dateString) ? new Date(dateString) : dateString;
};

_DateManager.isValid = function (param) {
    param = this.toDate(param);
    return Object.prototype.toString.call(param) === '[object Date]' && param.toString() !== 'Invalid Date';
};

_DateManager.getYYYYMMDD = function (param, skipValidation) {
    param = this.toDate(param);

    if (!skipValidation && !_DateManager.isValid(param)) {
        return null;
    }

    var date = new Date(param),
        month = '' + (1 + date.getMonth()),
        day = '' + date.getDate();

    month = month.length === 1 ? '0' + month : month;
    day = day.length === 1 ? '0' + day : day;

    return date.getFullYear() + '-' + month + '-' + day;
};

_DateManager.getTimeDifference = function (date) {
    var seconds = Math.floor((new Date() - new Date(date)) / 1000);

    // Dirty hack to avoid having negative time due to difference between client zone and server zone
    while (seconds < 0) {
        seconds += 3600;
    }
    var interval = Math.floor(seconds / 31536000);

    if (interval > 1) {
        return interval + " years";
    }
    interval = Math.floor(seconds / 2592000);
    if (interval > 1) {
        return interval + " months";
    }
    interval = Math.floor(seconds / 86400);
    if (interval > 1) {
        return interval + " days";
    }
    interval = Math.floor(seconds / 3600);
    if (interval > 1) {
        return interval + " hours";
    }
    interval = Math.floor(seconds / 60);
    if (interval > 1) {
        return interval + " minutes";
    }
    return Math.floor(seconds) + " seconds";
};
//# sourceMappingURL=DateManager.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/lib/manager/DateManager.js
 ** module id = 28
 ** module chunks = 0 1
 **/